export const images = {
  tajirikaLogo: "/assets/logoL.png",
  tajirikaLogoD: "/assets/logoD.png",
};
